"use strict";

function setCookie(cname, cvalue) {
  var now = new Date();
  now.setTime(now.getTime() + 1 * 3600 * 1000 * 24);
  var expires = "expires=" + now.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires;
}

function deleteCookie(cname, cvalue) {
  var now = new Date();
  now.setTime(now.getTime() - 2 * 3600 * 1000 * 24);
  var expires = "expires=" + now.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires;
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}

function checkIfCookieExists(cookieName) {
  var cookie = getCookie(cookieName);

  if (cookie != undefined && cookie != "") {
    return true;
  } else {
    return false;
  }
}

function checkCookie(cookieName) {
  var cookie = getCookie(cookieName);

  if (cookie != "") {
    return cookie;
  } else {
    return false;
  }
}

function clearAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var equals = cookies[i].indexOf("=");
    var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
//# sourceMappingURL=cookies.js.map
